import { render, staticRenderFns } from "./scope9.vue?vue&type=template&id=04901f6a&scoped=true"
import script from "./scope9.vue?vue&type=script&lang=js"
export * from "./scope9.vue?vue&type=script&lang=js"
import style0 from "./scope9.vue?vue&type=style&index=0&id=04901f6a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04901f6a",
  null
  
)

export default component.exports